import { render, staticRenderFns } from "./NeedsOnboarding.vue?vue&type=template&id=257446b7&scoped=true&"
import script from "./NeedsOnboarding.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsOnboarding.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257446b7",
  null
  
)

export default component.exports